export const SubHeader = {
  baseStyle: {
    padding: '0',
    margin: '0 auto 70px auto',
    textAlign: 'center',
    color: 'brand.white',
    border: 'none',
    borderTop: 'solid 1px',
    borderTopColor: 'brand.white', // needs to be separate for Chakra UI to style colour (can't put colour in shorthand 'border' property)
    ':focus': {
      border: '0',
      outline: '0',
      borderTop: 'solid 1px',
      borderTopColor: 'brand.white', // needs to be separate for Chakra UI to style colour (can't put colour in shorthand 'border' property)
    },
  },
};

export const SubHeaderItem = {
  parts: ['Container', 'Title', 'Category'],
  baseStyle: {
    Container: {
      margin: '0 auto',
      padding: '36px 0px',
      textAlign: 'center',
      flexDirection: 'column-reverse', // so that the category is read out first by screen readers, but displayed last per the design
    },
    Title: {
      fontSize: '24px',
      fontWeight: 400,
    },
    Category: {
      fontSize: '14px',
      fontWeight: 400,
    },
  },
  variant: {
    Container: {
      hasLeftItem: {
        borderTop: 'solid 1px',
        borderTopColor: 'brand.white', // needs to be separate for Chakra UI to style colour (can't put colour in shorthand 'border' property)
      },
    },
  },
};
